import React, { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { editPersonalizedConfigOptions } from "~/store/actions/actions.personalizedConfigOptions.jsx";
import { getObjectTotalExpenses, getObjectTotalTime } from "~/store/selectors/selector.additionalObjectData.jsx";
import { getRawPersonalizedConfigOption } from "~/store/selectors/selector.configOptions.jsx";
import { makeGetCanLoggedUserEditTaskSelector } from "~/store/selectors/selector.objectPermissions.jsx";
import { makeGetOpenDependenciesCountByIdSelector } from "~/store/selectors/selector.tasks.jsx";
import TrashTaskLink from "./TrashTaskLink.jsx";

const TrashTaskContainer = ({ taskId, onClick, ...props }) => {
  const dispatch = useDispatch();
  const getOpenDependenciesCountById = useMemo(makeGetOpenDependenciesCountByIdSelector, []);
  const dependenciesCount = useSelector((state) => getOpenDependenciesCountById(state, taskId));

  const canEdit = useSelector((state) => makeGetCanLoggedUserEditTaskSelector(state, taskId));

  const trashTrackingObjects = useSelector((state) => getRawPersonalizedConfigOption(state, "trash_tracking_objects"));

  const trackedExpenses = useSelector((state) => getObjectTotalExpenses(state, "Task", taskId));
  const trackedTime = useSelector((state) => getObjectTotalTime(state, "Task", taskId));

  const hasTracking = useMemo(() => trackedExpenses > 0 || trackedTime > 0, [trackedExpenses, trackedTime]);

  const handleOnClick = useCallback(
    (trashTracking) => {
      if (trashTracking !== trashTrackingObjects) {
        dispatch(
          editPersonalizedConfigOptions({
            trash_tracking_objects: trashTracking,
          })
        );
      }

      typeof onClick === "function" && onClick(trashTracking);
    },
    [dispatch, onClick, trashTrackingObjects]
  );

  if (!canEdit) return null;

  return (
    <TrashTaskLink
      onClick={handleOnClick}
      dependenciesCount={dependenciesCount}
      hasTracking={hasTracking}
      trashTrackingObjects={trashTrackingObjects}
      {...props}
    />
  );
};

TrashTaskContainer.propTypes = {
  taskId: PropTypes.number,
  onClick: PropTypes.func,
};

export default TrashTaskContainer;
